var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('contractor-control'),_c('contractor-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }